import Collapse from './Collapse';
export default Collapse;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/collapse/index.js
// module id = 766
// module chunks = 0